import React from "react";
import "./Navbar.css";
import { Avatar } from "../../assets";

function Navbar() {
  return (
    <>
      <nav className="prac-nav">
        <div className="prac-dashboard-icon">
          <div className="search">
            <svg
              width="25"
              height="48"
              viewBox="0 0 27 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.9189 24.1311L18.154 15.6909C19.5142 13.9977 20.2499 11.9274 20.2499 9.74996C20.2499 7.14347 19.1935 4.69948 17.2833 2.85674C15.3731 1.014 12.8283 0 10.125 0C7.42159 0 4.87685 1.01725 2.96661 2.85674C1.053 4.69623 0 7.14347 0 9.74996C0 12.3532 1.05637 14.8037 2.96661 16.6432C4.87685 18.4859 7.41822 19.4999 10.125 19.4999C12.3862 19.4999 14.5327 18.7914 16.2911 17.4849L25.0559 25.9219C25.0816 25.9466 25.1121 25.9663 25.1457 25.9797C25.1793 25.9931 25.2153 26 25.2516 26C25.288 26 25.324 25.9931 25.3576 25.9797C25.3912 25.9663 25.4217 25.9466 25.4474 25.9219L26.9189 24.5081C26.9446 24.4834 26.965 24.454 26.9789 24.4217C26.9928 24.3893 27 24.3547 27 24.3196C27 24.2846 26.9928 24.25 26.9789 24.2176C26.965 24.1853 26.9446 24.1559 26.9189 24.1311ZM15.4709 14.8979C14.0399 16.2727 12.1432 17.0299 10.125 17.0299C8.10671 17.0299 6.20997 16.2727 4.77898 14.8979C3.35136 13.5199 2.56499 11.6934 2.56499 9.74996C2.56499 7.80647 3.35136 5.97672 4.77898 4.60198C6.20997 3.22724 8.10671 2.46999 10.125 2.46999C12.1432 2.46999 14.0433 3.22399 15.4709 4.60198C16.8986 5.97997 17.6849 7.80647 17.6849 9.74996C17.6849 11.6934 16.8986 13.5232 15.4709 14.8979Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="notification-bell">
            <svg
              width="25"
              height="48"
              viewBox="0 0 30 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.0253 25.5676L28.7042 25.2843C27.7932 24.4726 26.9958 23.5418 26.3336 22.517C25.6104 21.1028 25.1769 19.5583 25.0586 17.9743V13.3087C25.0548 12.742 25.0043 12.1766 24.9075 11.6181C23.3077 11.2893 21.8707 10.4178 20.8398 9.15105C19.8089 7.88432 19.2473 6.30026 19.2503 4.66704V4.07204C18.2642 3.58677 17.2048 3.26766 16.1147 3.12759V1.93759C16.1147 1.6032 15.9819 1.2825 15.7455 1.04605C15.509 0.809595 15.1883 0.676758 14.8539 0.676758C14.5195 0.676758 14.1988 0.809595 13.9624 1.04605C13.7259 1.2825 13.5931 1.6032 13.5931 1.93759V3.17481C11.1524 3.51911 8.91862 4.73479 7.30423 6.59742C5.68985 8.46004 4.80382 10.8438 4.80975 13.3087V17.9743C4.69146 19.5583 4.25798 21.1028 3.53475 22.517C2.88391 23.5393 2.09938 24.4699 1.20197 25.2843L0.880859 25.5676V28.2309H29.0253V25.5676Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="prac-profile-container">
            <h3>Thomas</h3>
            <div className="prac-profile-avatar">
              <img src={Avatar} alt="avatar" />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export { Navbar };
